// src/pages/HomeAlgolia.jsx
import React from 'react';
import { getAlgoliaClient } from '../services/searchClient';

const INDEX = (import.meta.env.VITE_ALGOLIA_INDEX || 'imoveis').trim();

export default function HomeAlgolia() {
  const [hits, setHits] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const buscar = React.useCallback(async () => {
    setLoading(true);
    const { type, index } = await getAlgoliaClient({ indexName: INDEX });
    if (type === 'algolia') {
      const res = await index.search('', { hitsPerPage: 10 });
      setHits(res.hits || []);
    } else {
      setHits([]); // (opcional) poderia chamar searchProperties aqui
    }
    setLoading(false);
  }, []);

  React.useEffect(() => {
    buscar();
  }, [buscar]);

  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold mb-4">Teste Algolia</h1>
      {loading ? (
        'Carregando...'
      ) : (
        <ul className="space-y-2">
          {hits.map((h) => (
            <li key={h.objectID}>
              {h.titulo} — {h.cidade}/{h.estado} — R${' '}
              {Number(h.preco || 0).toLocaleString('pt-BR')}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
